module.exports = __webpack_public_path__ + "img/englishBrandImg.d6b81ab2.png";